import React from 'react'
import LogoImg from '../../images/logo.png'

const Logo = props => {
  return <img alt="Logo" className="logo-img" src={LogoImg} {...props} />
}

export default Logo
